import ReceivedInvoiceCrud from "../components/received-invoice/ReceivedInvoiceCrud";

const ReceivedInvoicesPage = () => {
  return <ReceivedInvoiceCrud />;
};

export default ReceivedInvoicesPage;
